import React, { FC } from "react";
import {
  FormController,
  MuiGrid,
  MuiSelectWithTextInput,
  OptionsDataType,
} from "../../../../../components";
import { ProgramSearchProgramFormKey } from "../../../modelsAndSchemas/models";
import { MAX_LENGTH_50 } from "../../../../../helpers/constants";
import { programSearchSiteCoreKeys } from "../../../siteCore/SiteCoreKeys";
import { useGridContainer } from "../../../../../hooks/useGridContainer";
import { useFormContext } from "react-hook-form";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { useNavigationSiteCore } from "../../../../../hooks/useNavigationSiteCore";

interface ParticipantNameFieldsProps {
  pageId: string;
  filterDropdownValue: OptionsDataType[];
  firstNameMaxLength?: number;
  lastNameMaxLength?: number;
}
export const ParticipantsNameFields: FC<ParticipantNameFieldsProps> = ({
  pageId,
  filterDropdownValue,
  firstNameMaxLength = MAX_LENGTH_50,
  lastNameMaxLength = MAX_LENGTH_50,
}) => {
  const { gridSizeLarge: gridSize, gridSizeLargeClass } = useGridContainer();
  const { control } = useFormContext();
  const { commonLabels, useFetchLabel, commonValidationMessages } = useSiteCore();

  const getLabel = useFetchLabel(programSearchSiteCoreKeys.searchFormKey);

  const { commonARIALabel } = useNavigationSiteCore();
  return (
    <>
      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.participantFirstName}
        >
          <MuiSelectWithTextInput
            options={filterDropdownValue}
            label={getLabel(programSearchSiteCoreKeys.participantFirstName)}
            placeholder={commonLabels.inputPlaceHolder}
            control={control}
            selectBoxName={
              ProgramSearchProgramFormKey.participantFirstNameFilter
            }
            id={`${pageId}-${ProgramSearchProgramFormKey.participantFirstName}`}
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.participantFirstNameFilter}`}
            maxLength={firstNameMaxLength}
            requiredARIALabel={commonARIALabel.required}
            tooltipMessage={
              commonValidationMessages.fieldSpecialCharactersTooltipMessage
            }
            tooltipHeaderTitle={
              commonValidationMessages.allowedSpecialCharactersTitle
            }
          />
        </FormController>
      </MuiGrid>
      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.participantLastName}
        >
          <MuiSelectWithTextInput
            options={filterDropdownValue}
            label={getLabel(programSearchSiteCoreKeys.participantLastName)}
            placeholder={commonLabels.inputPlaceHolder}
            control={control}
            selectBoxName={
              ProgramSearchProgramFormKey.participantLastNameFilter
            }
            id={`${pageId}-${ProgramSearchProgramFormKey.participantLastName}`}
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.participantLastNameFilter}`}
            maxLength={lastNameMaxLength}
            requiredARIALabel={commonARIALabel.required}
            tooltipMessage={
              commonValidationMessages.fieldSpecialCharactersTooltipMessage
            }
            tooltipHeaderTitle={
              commonValidationMessages.allowedSpecialCharactersTitle
            }
          />
        </FormController>
      </MuiGrid>
    </>
  );
};
